import template from './timeline.html'

const width = window.screen.width
const height = 60

var PIXEL_RATIO = (function () {
    const ctx = document.createElement("canvas").getContext("2d"),
        dpr = window.devicePixelRatio || 1,
        bsr = ctx.webkitBackingStorePixelRatio ||
            ctx.mozBackingStorePixelRatio ||
            ctx.msBackingStorePixelRatio ||
            ctx.oBackingStorePixelRatio ||
            ctx.backingStorePixelRatio || 1

    return dpr / bsr;
})()

const createHiDPICanvas = function (w, h, ratio) {
    if (!ratio) { ratio = PIXEL_RATIO; }
    var can = document.createElement("canvas");
    can.width = w * ratio;
    can.height = h * ratio;
    can.style.width = w + "px";
    can.style.height = h + "px";
    can.getContext("2d").setTransform(ratio, 0, 0, ratio, 0, 0);
    return can;
}

const ru_RU = {
    "decimal": ",",
    "thousands": "\xa0",
    "grouping": [3],
    "currency": ["", " руб."],
    "dateTime": "%A, %e %B %Y г. %X",
    "date": "%d.%m.%Y",
    "time": "%H:%M:%S",
    "periods": ["AM", "PM"],
    "days": ["воскресенье", "понедельник", "вторник", "среда", "четверг", "пятница", "суббота"],
    "shortDays": ["вс", "пн", "вт", "ср", "чт", "пт", "сб"],
    "months": ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"],
    "shortMonths": ["Янв", "Фев", "Мар", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
}

const RU = d3.timeFormatDefaultLocale(ru_RU)

const timelineComponent = ({ onMove, onChange }) => {
    var canvas = createHiDPICanvas(width, height)
    const context = canvas.getContext('2d')
    let scale = null
    let zoom = null
    const w = width
    const h = height
    const m = 800
    const ctx = context
    const tickColor = tailwind.colors.gray[300]
    const centralLineColor = tailwind.colors.red[500]
    const fontColor = tailwind.colors.slate[600]
    const hasTimeColor = tailwind.colors.red[500]
    const backgroundColor = tailwind.colors.gray[200]
    const bottomLineColor = tailwind.colors.gray[300]
    const format = RU.format('%H:%M')
    let isReady = false
    let hasTime = []

    const zoomed = transform => {
        context.save()
        context.clearRect(0, 0, width, height);
        ctx.fillStyle = backgroundColor
            //ctx.fill()
        ctx.fillRect(0, 0, width, height)
            //ctx.closePath()
        //context.translate(transform.x, 0);
        //context.scale(transform.k, transform.k);

        //const scale = transform.rescaleX(initScale)
        if (onMove) onMove(scale.invert(-transform.x - m))

        ctx.strokeStyle = bottomLineColor
        ctx.beginPath()
        ctx.lineWidth = 4;
        ctx.moveTo(0, h-2)
        ctx.lineTo(w, h-2)
        ctx.stroke()

        for (let t of scale.ticks(d3.timeMinute.every(60))) {
            const x = scale(t)
            ctx.strokeStyle = tickColor

            ctx.beginPath()
            ctx.lineWidth = 1;
            ctx.moveTo(x + transform.x, h-4)
            ctx.lineTo(x + transform.x, h-20)
            ctx.stroke()

            ctx.fillStyle = fontColor
            ctx.font = "12px Arial"
            ctx.fillText(format(t), x + transform.x - 16, h - 26)
        }

        for (let t of scale.ticks(d3.timeMinute.every(30))) {
            const x = scale(t)
            ctx.strokeStyle = tickColor

            ctx.beginPath()
            ctx.lineWidth = 1;
            ctx.moveTo(x + transform.x, h-4)
            ctx.lineTo(x + transform.x, h-12)
            ctx.stroke()
        }

        hasTime.forEach(item => {
            //console.log(item)
            const x = scale(item.b)
            const x2 = scale(item.e)
            //ctx.globalAlpha = 0.2;
            //ctx.fillStyle = hasTimeColor
            //context.fillRect(x + transform.x, 0, h, 50);
            ctx.strokeStyle = hasTimeColor

            ctx.beginPath()
            ctx.lineWidth = 4;
            ctx.moveTo(x + transform.x, h-2)
            ctx.lineTo(x2 + transform.x, h-2)
            ctx.stroke()
        })

        context.fill()
        context.restore()

        ctx.beginPath()
        ctx.moveTo(w * 0.5, 0)
        ctx.lineTo(w * 0.5, h)
        ctx.strokeStyle = centralLineColor
        ctx.stroke()
    }

    return {
        init() {
            this.$nextTick(() => {
                this.$el.innerHTML = template
                document.getElementById('timeline').append(canvas)
            })
            this.create()
        },
        setDate(begin, end) {
            scale = d3
                .scaleTime()
                .domain([begin, end])
                .range([w * 0.5, w + m])
                hasTime = []
            if (isReady) {
                d3.select(canvas).call(zoom.transform, d3.zoomIdentity)
                //zoomed(d3.zoomIdentity)
            }
        },
        create() {
            ctx.clearRect(0, 0, w, h)
            let interval = null
            zoom = d3.zoom()
                .scaleExtent([1, 1])
                .translateExtent([[0, 0], [w + w * 0.5 + m - 0.01, h]])
                .on("zoom", ({ transform }) => zoomed(transform))
                .on("start", function (e) {
                    console.log('start')
                    if (e.sourceEvent == null) return
                    clearInterval(interval)
                })
                .on("end", function () {
                    if (onChange) onChange()
                })

            d3.select(canvas).call(zoom)


            //const format = scale.tickFormat(RU.format('%M'))
            
            let isStop = false
            let index = 0
            /*interval = setInterval(()=>{
              d3.select(canvas).call(zoom.transform, d3.zoomIdentity
              .translate(index, 0));
              index -=1
            },100)*/


            zoomed(d3.zoomIdentity)


            /*var d0 = new Date(2003, 0, 1),
               d1 = new Date(2004, 0, 1);
         
         svg.call(zoom.transform, d3.zoomIdentity
             .scale(width / (x(d1) - x(d0)))
             .translate(-x(d0), 0));*/


            //d3.zoomIdentity.translate(100, 50).scale(1)
            //zoomed(d3.zoomIdentity);
            //zoomed(d3.zoomIdentity);
            isReady = true
        },
        update(value) {
            hasTime = value
            zoomed(d3.zoomIdentity)
        }
    }
}

export { timelineComponent }
